import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { getToken } from '@/utils/auth'
// import { getDomain } from '@/utils'
import qs from 'querystring'

// create an axios instance
// const service = axios.create({
//   baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
//   // withCredentials: true, // send cookies when cross-domain requests
//   timeout: 5000 // request timeout
// })
const service = axios.create({
  baseURL:  "https://make.ivymei.com", // api 的 base_url
  timeout: 60000, // request timeout multipart/form-data  application/x-www-form-urlencoded
  headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
  /*withCredentials: true,
  crossDomain: true*/
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    // if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['X-Token'] = getToken()
      config.data = config.data || {};
      config.params = config.params || {};
      config.data.token = getToken();
      config.params.token = getToken();
    // }
    config.data = qs.stringify(config.data);
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
    /* response => response,*/
    /**
     * 下面的注释为通过在response里，自定义code来标示请求状态
     * 当code返回如下情况则说明权限有问题，登出并返回到登录页
     * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
     * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
     */
    response => {
      const res = response.data
      // console.log(res,'resresresres')
      if (res.imei_error_code !== "0") {
        if (res.imei_error_code != 600) {
          if (res.imei_error_msg) {
            // Message({
            //   // message: res.imei_error_msg,
            //   type: 'error',
            //   duration: 2000
            // })
          }
        }

        // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
        if (res.imei_error_code ===  202009) {
          // window.location.href = getDomain();
        }

        if (res.imei_error_code === 202004) {
          /*location.reload()*/
          // store.dispatch('FedLogOut').then(() => {
          //   location.reload() // 为了重新实例化vue-router对象 避免bug
          // })
        }

        if (res.imei_error_code === 600) {
          // 请自行在引入 MessageBox
          // import { Message, MessageBox } from 'element-ui'
          MessageBox.confirm('你已被登出，请重新登录', '确定登出', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // store.dispatch('FedLogOut').then(() => {
            //   location.reload() // 为了重新实例化vue-router对象 避免bug
            // })
          }).catch(()=> {
            // store.dispatch('FedLogOut').then(() => {
            //   location.reload() // 为了重新实例化vue-router对象 避免bug
            // })
          })
          return response.data
        }
        //return response.data
        if (res.imei_error_code == '202007')  {
          return Promise.reject(response.data)
        }
        return response.data

      } else {
        return response.data
      }
    },
    error => {
      console.log('err' + error) // for debug
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js